import {css} from '@emotion/css';
import {colours} from '@fo/shared/styles/variables/colours';

const styles = {
  openAndCloseArrow: (isOpen?: boolean): string => css`
    label: openAndCloseArrow;
    transition: transform 250ms;
    * {
      fill: ${colours.brand.SECONDARY};
    }
    ${isOpen &&
    css`
      transform: rotate(90deg);
    `}
  `,
};

export default styles;
